import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';

interface TypePriseSelectProps {
    setSelectedTypePrise: (numero: string) => void;
}

type TypePrise = { key: string; value: string };

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const TypePriseSelect: React.FC<TypePriseSelectProps> = ({ setSelectedTypePrise }) => {
    const typePrises: TypePrise[] = [
        { key: '', value: '- Toutes' },
        { key: 'Crédit', value: 'Crédit' },
        { key: 'Provision', value: 'Provision' },
    ];

    const options: ISelectOption[] = typePrises.map((type) => ({
        value: type.key,
        label: type.value,
    }));

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedTypePrise(selectedOption ? selectedOption.value : '');
    };

    return <Select id="autoSizingSelect" options={options} onChange={handleChange} placeholder={'--- Type'} isClearable isSearchable styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} />;
};

export default TypePriseSelect;
